// extracted by mini-css-extract-plugin
export default {"dropcap":"DropCap_dropcap__X0fmo","dropcap-letter":"DropCap_dropcap-letter__og1WX"};